import api from "./client";

export function getMyReleasedDocuments(inmateId) {
  return api.get(`/inmates/${inmateId}/documents`);
}

export function viewReleasedDocument(inmateId, documentId) {
  return api.get(`/inmates/${inmateId}/documents/${documentId}/view`, {
    responseType: "blob",
  });
}
